import React from "react";
import styled from "styled-components";
import { H3 } from "storybook-components/Typography";
import CategoryPageLink from "./CategoryPageLink";

const CategoryTitle = styled(H3)`
  margin: 0;
  color: ${({ theme }) => theme.colors.green5};
`;

const CategoryTitleSection = styled.div`
  display: flex;
  justify-content: space-between;
  ${props => props.theme.media.desktopUp`
    justify-content: flex-start;
  `};
`;

export default ({ categoryName, categoryPath }) => (
  <CategoryTitleSection>
    <CategoryTitle>{categoryName}</CategoryTitle>
    {categoryPath && (
      <CategoryPageLink
        to={`/category/${categoryPath}`}
        linkText="More articles"
      />
    )}
  </CategoryTitleSection>
);
